export class SetDisplayingLanguages {
  static readonly type = '[Translation Editor] Set Displaying Languages';
  constructor(public payload: Array<string>) {}
}
